import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const DestinationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#e8eaed"
    >
      <path d="M480-192.46q120.33-110.08 178.73-198.59 58.4-88.52 58.4-161.91 0-107.31-68.67-175.74t-168.47-68.43q-99.79 0-168.46 68.43-68.66 68.43-68.66 175.74 0 73.39 58.4 161.79 58.4 88.39 178.73 198.71Zm-.06 92.16q-14.9 0-29.75-5.24-14.86-5.24-26.54-15.72-66.43-60.72-117.39-117.96-50.96-57.24-85.05-111.21-34.1-53.98-51.72-104.56-17.62-50.58-17.62-97.97 0-153.28 98.95-244.22 98.95-90.95 229.18-90.95 130.23 0 229.18 90.95 98.95 90.94 98.95 244.22 0 47.39-17.62 97.97t-51.72 104.56q-34.09 53.97-85.05 111.21-50.96 57.24-117.39 117.96-11.71 10.48-26.61 15.72-14.9 5.24-29.8 5.24ZM480-560Zm0 82.39q34.2 0 58.29-24.1 24.1-24.09 24.1-58.29t-24.1-58.29q-24.09-24.1-58.29-24.1t-58.29 24.1q-24.1 24.09-24.1 58.29t24.1 58.29q24.09 24.1 58.29 24.1Z" />
    </SvgIcon>
  );
};
